// Import model
import { ActionMenuItem } from '../models/ActionMenuItem';

// Import base class serializer
import { MenuItemSerializer } from './MenuItemSerializer';

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for ActionMenuItem - handles JSON serialization and deserialization with type validation
 */
export class ActionMenuItemSerializer {
  /**
   * Deserializes a JSON string into a ActionMenuItem instance
   */
  static deserialize(json: string): ActionMenuItem {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a ActionMenuItem instance
   */
  static fromObject(obj: any): ActionMenuItem {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to ActionMenuItem');
    }


    const instance: ActionMenuItem = {
      icon: obj['Icon'] as string | undefined,
      t: obj['_t'] as string,
      name: obj['Name'] as string,
      label: obj['Label'] as string | undefined,
      enable: obj['Enable'] ? (obj['Enable'] as any[]).map((item: any) =>
        item as string
      ) : [] as any,
      visible: obj['Visible'] ? (obj['Visible'] as any[]).map((item: any) =>
        item as string
      ) : [] as any,
      action: obj['Action'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of ActionMenuItem instances
   */
  static deserializeArray(json: string): ActionMenuItem[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a ActionMenuItem instance to a JSON string
   */
  static serialize(instance: ActionMenuItem): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a ActionMenuItem instance to a plain object
   */
  static toObject(instance: ActionMenuItem): any {
    return {
      'Icon': instance.icon,
      '_t': instance.t,
      'Name': instance.name,
      'Label': instance.label,
      'Enable': instance.enable?.map((item: any) =>
        item
      ),
      'Visible': instance.visible?.map((item: any) =>
        item
      ),
      'Action': instance.action,
    };
  }

  /**
   * Serializes an array of ActionMenuItem instances to a JSON string
   */
  static serializeArray(instances: ActionMenuItem[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
